<div class="ui-project__header">
  <h3 class="mb-0">{{ 'ProjectSummary.email' | translate }}</h3>
</div>
<router-outlet />
